export default __webpack_public_path__ + "static/media/main-img1-3.a05f9c3f.png";